export default __webpack_public_path__ + "static/media/18.2613274a.jpeg";